/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ResponseWithErrorGeneric } from '../shared/response-with-error-generic';
import { GetPackageCategoriesResponseJson } from './get-package-categories-response-json';
import { GetPackageCategoriesResult } from '../results/get-package-categories-result.enum';
import { IResponseWithErrorGeneric } from '../shared/iresponse-with-error-generic.interface';
import { PackageCategoryDto } from '../models/package-category-dto';

//<custom-head>
import { HttpResponse } from '@angular/common/http';
//</custom-head>

export class GetPackageCategoriesResponse extends ResponseWithErrorGeneric<GetPackageCategoriesResponseJson, GetPackageCategoriesResult> implements IResponseWithErrorGeneric<GetPackageCategoriesResult> {
  public packageCategories: PackageCategoryDto[];

  //<custom-body>
  constructor(response: HttpResponse<GetPackageCategoriesResponse>) {
    super(response, GetPackageCategoriesResult.Error);
    if (this.result !== GetPackageCategoriesResult.Success) return;

    if (this.body.packageCategories != null)
      this.packageCategories = this.body.packageCategories.map(cat => new PackageCategoryDto(cat));
  }
  //</custom-body>
}
